import React from "react";
import { useLocalizationString } from "../../../store/localization/useSelectors";
import { useChangeLanguage } from "../../../store/localization/useActions";
import ChangeLanguage from "./ChangeLanguage";

const Container = () => {
  const locale = useLocalizationString();
  const changeLocalization = useChangeLanguage();

  return <ChangeLanguage locale={locale} changeLocale={changeLocalization} />;
};

export default Container;
